export default __webpack_public_path__ + "images/7f1f1870aaab4fb66cd6053d73c26058-animalwelfare.jpg";